<template>
  <b-col :sm="busWideView" class="mt-2" :style="busWideView == 3 ? 'display: block;' : 'display: none;'">
    <div class="sticky-card-bus">
      <div class="card ">
        <div class="card-header main-card">
          {{ busTableTitle }}
          
          <b-dropdown
            dropleft
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            class="float-right"
          >
            <template v-slot:button-content>
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item>
              <div v-b-modal="'addNewBus'">
                <i class="fa fa-edit mr-2 fa-fw"/> Añadir bus
              </div>
              <!-- <add-bus-modal /> -->
              <add-new-bus-modal />
            </b-dropdown-item>
            <b-dropdown-item>
              <ResetAssignedBusesByType 
                
              />
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="card-body">
          <BusCard
            @selectedBusId="busId = $event"
            :buses="buses"
            :busesType="busesTypeForCard"
          />
        </div>
      </div>
      <div class="card mt-5">
        <div class="card-header main-card">
          Reservas y PAX por subzona de recogida
        </div>
        <div class="card-body">
          <div v-for="item in pickupzoneSummary" :key="item.pickupzone_name" class="mb-3">
            <span class="font-weight-bold text-uppercase mr-3">{{item.pickupzone_name}}: </span><span>{{item.total_pax}}</span>
          </div>
        </div>
      </div>
    </div>
    
  </b-col>
</template>

<script>
import { mapGetters } from "vuex";
import ResetAssignedBusesByType from "../ResetAssignedBusesByType";
import BusCard from "./BusCard/BusCard";
import { EventBus } from "../../../EventBus";
import AddNewBusModal from './BusModal/AddNewBusModal';

export default {
  name: "Bus",
  data() {
    return {
      busId: ""
    };
  },
  components: {
    BusCard,
    ResetAssignedBusesByType,
    AddNewBusModal
  },
  computed: {
    ...mapGetters(["excursionBuses"]),
    ...mapGetters(["pickupBuses"]),
    ...mapGetters(["returnBuses"]),
    ...mapGetters(['pickupzoneSummary']),
    ...mapGetters(['activeOption', 'activeTab']),
    ...mapGetters(['bookingsWideView', 'busWideView']),
    busesTypeForCard() {
      if ( this.$route.path == '/app/excursiones/excursiones' )
        return 'excursion'
      else if ( this.$route.path == '/app/excursiones/pickups')
        return 'pickup'
      else if ( this.$route.path == '/app/excursiones/returns' )
        return 'return'
    },
    buses() {
      if ( this.$route.path == '/app/excursiones/excursiones' )
        return this.excursionBuses
      else if ( this.$route.path == '/app/excursiones/pickups')
        return this.pickupBuses
      else if ( this.$route.path == '/app/excursiones/returns' )
        return this.returnBuses
      
    },
    busTableTitle() {
      if ( this.$route.path == '/app/excursiones/excursiones' )
        return 'Buses de Excursión'
      else if ( this.$route.path == '/app/excursiones/pickups') 
        return 'Buses de Recogida'
      else if ( this.$route.path == '/app/excursiones/returns')
        return 'Buses de Devolución'
    }
  },
  watch: {
    busId: function(val) {
      // sent bus id data to parent when it changes
      if (val) {
        this.$emit("busIdUpdated", this.busId);
      } else {
        this.$emit("busIdUpdated", "");
      }
    }
  },
  created() {
    EventBus.$on("busIdChange", busId => {
      this.busId = busId;
    });
  }
};
</script>

<style>
.dropleft .dropdown-toggle::before {
  display: none !important;
}
</style>